module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Light.2ce5f94.eot";